export class EmployeeManagerRequest {
  name: string = "";
  birthday: string = "";
  gender: number = 1;
  avatar: string = "";
  phone: string = "";
  address: string = "";
  username: string = "";
  joining_date: string = "";
  constructor(data?: Partial<EmployeeManagerRequest>) {
    Object.assign(this, data);
  }
}
